export default function CasaMapaAdminAnalyticsDateToolbar({
  range,
  activePreset,
  presets,
  onPreset,
  onStartDateChange,
  onEndDateChange,
}) {
  return (
    <div className="cm-admin-analytics__toolbar">
      <div className="cm-admin-analytics__presets">
        {presets.map((preset) => (
          <button
            key={preset.label}
            type="button"
            className={`cm-admin-analytics__preset${
              activePreset === preset.label ? " cm-admin-analytics__preset--active" : ""
            }`}
            onClick={() => onPreset(preset)}
          >
            {preset.label}
          </button>
        ))}
      </div>
      <div className="cm-admin-analytics__date-range">
        <input
          type="date"
          className="cm-admin-analytics__date-input"
          value={range.startDate}
          onChange={(event) => onStartDateChange(event.target.value)}
        />
        <span className="cm-admin-analytics__date-sep">—</span>
        <input
          type="date"
          className="cm-admin-analytics__date-input"
          value={range.endDate}
          onChange={(event) => onEndDateChange(event.target.value)}
        />
      </div>
    </div>
  );
}
